import { WorkosTeamMappingModel } from "./WorkosTeamMapping.model";

export class WorkosTeamMapping extends WorkosTeamMappingModel {
    // Add custom methods here
}
